import { TextInput } from "./TextInput";
import { forwardRef } from "react";
import { EyeIcon, PrivacyIcon } from "../../icons";
import { IconButton } from "../../button";
import { mergeProps, useControllableState, useEventCallback } from "../../shared";
import { useInputGroupTextInputProps } from "../../input-group";
import { useState } from "react";
import { wrappedInputPropsAdapter } from "../../input";
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultElement = "input";
export function InnerPasswordInput(props) {
  const [inputGroupProps] = useInputGroupTextInputProps();
  const {
    as = DefaultElement,
    defaultValue,
    forwardedRef,
    value,
    wrapperProps,
    ...rest
  } = mergeProps(props, wrappedInputPropsAdapter(inputGroupProps));
  const [inputValue, setValue] = useControllableState(value, defaultValue, "");
  const [isHidden, setIsHidden] = useState(true);
  const handleChange = useEventCallback(event => {
    setValue(event.target.value);
  });
  const handleShowValue = useEventCallback(() => {
    setIsHidden(x => !x);
  }); // Always show the button to play nice with password managers.

  const showButtonMarkup = /*#__PURE__*/_jsx(IconButton, {
    "aria-label": "Toggle password visibility",
    className: "o-ui-password-input-show-button",
    onClick: handleShowValue,
    title: "Toggle password visibility",
    variant: "tertiary",
    children: isHidden ? /*#__PURE__*/_jsx(EyeIcon, {}) : /*#__PURE__*/_jsx(PrivacyIcon, {})
  });

  return /*#__PURE__*/_jsx(TextInput, { ...mergeProps(rest, {
      as,
      button: showButtonMarkup,
      onChange: handleChange,
      ref: forwardedRef,
      type: isHidden ? "password" : "text",
      value: inputValue,
      wrapperProps: mergeProps(wrapperProps !== null && wrapperProps !== void 0 ? wrapperProps : {}, {
        className: "o-ui-password-input"
      })
    })
  });
}
InnerPasswordInput.defaultElement = DefaultElement;
export const PasswordInput = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerPasswordInput, { ...props,
  forwardedRef: ref
}));